import { AdjustTermKey, AdjustTerms, isDefined } from '@aloft/toolkit-shared';

import { AdjustGridRowSchema, AdjustGridSchema } from './types';

export function findDisplayFormatForTerm(
  schema: AdjustGridSchema,
  term: AdjustTermKey,
): AdjustGridRowSchema['getDisplayValue'] | undefined {
  const termInfo = AdjustTerms[term];
  if (isDefined(termInfo.getPairedSaleDisplayValue)) {
    return termInfo.getPairedSaleDisplayValue;
  }
  for (const rowGroup of schema.rowGroups) {
    for (const row of rowGroup.rows) {
      if (row.terms.includes(term)) {
        return row.getDisplayValue;
      }
    }
  }
  return undefined;
}
